// 注册页面组件

import BasePage from '../pages/BasePage.vue';
import LeftRightPage from '../pages/LeftRightPage.vue';
import Page_1 from '../pages/Page_1.vue';

// 定义页面组件列表
const pageComponents: any = {
  BasePage,
  LeftRightPage,
  Page_1
};
export default pageComponents;
